import axios from 'axios'

export const fetchRescueCode = async(code) => {
  try {
    return await axios.get(`rescue-codes/${encodeURIComponent(code)}`)
  } catch (error) {
    throw error.response
  }
}

export const requestRefund = async(code, data) => {
  try {
    return await axios.put(`rescue-codes/${encodeURIComponent(code)}/refund`, data)
  } catch (error) {
    throw error.response
  }
}
